/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
// import { useCurrentDynamicField } from 'cms/fields/dynamic-field'

const ModelRefFieldDisplay = () => {
    
    // const { field } = useCurrentDynamicField()
    // const { values } = field || {}

    return (
        <>
            {/*<FieldDisplayWrapper>*/}
            {/*    {values &&*/}
            {/*        values.map((item, index) => {*/}
            {/*            const { value, settings } = item || {}*/}
            {/*            const { style, format, options } = settings || {}*/}
            {/*            return (*/}
            {/*                <Fragment key={index}>*/}
            {/*                    <DisplayTextOnly value={value} style={style} />*/}
            {/*                </Fragment>*/}
            {/*            )*/}
            {/*        })}*/}
            {/*</FieldDisplayWrapper>*/}
        </>
    );
};
ModelRefFieldDisplay.displayName = "ModelRefFieldDisplay";
export { ModelRefFieldDisplay };
